export default (context, text) => {
    context.text = text.replace(/[^А-Яа-я.!?0-9():^;, -]+/g, '')
}